import { useEffect } from 'react';
import { useJobsContext } from '../stores/jobs-context';

function useJobsLoading(): void {
  const { fetchData } = useJobsContext();

  useEffect(() => {
    fetchData();
  }, [fetchData]);
}

export default useJobsLoading;
